import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "signal-page" }
const _hoisted_2 = { class: "main" }
const _hoisted_3 = { class: "market-grid" }

import { ref } from 'vue'
import MarketSignal from '@/components/MarketSignal.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'signal',
  setup(__props) {

const markets = ref([
  {
    id: 'CN',
    name: '中国市场'
  },
  {
    id: 'US',
    name: '美国市场'
  }
])

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("header", { class: "header" }, [
      _createElementVNode("h1", null, "全球市场波动率信号灯"),
      _createElementVNode("p", null, "实时监测主要资本市场的波动情况，助你把握市场脉搏")
    ], -1)),
    _createElementVNode("main", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(markets.value, (market) => {
          return (_openBlock(), _createBlock(MarketSignal, {
            key: market.id,
            "market-id": market.id,
            name: market.name
          }, null, 8, ["market-id", "name"]))
        }), 128))
      ])
    ])
  ]))
}
}

})